module.exports = __webpack_public_path__ + "static/media/swap.d3610e08.wav";